import { RemoteActivityReportInternshipLocation } from 'data/usecases';
import { ActivityReportInternshipLocationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivityReportInternshipLocation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeActivityReportInternshipLocation =
  (): ActivityReportInternshipLocationUseCaseInterface =>
    new RemoteActivityReportInternshipLocation(
      makeApiUrlActivityReportInternshipLocation(),
      makeAxiosHttpClient(),
    );
